import type { SessionUser } from "@/api/types";

/** What the top navigation puts in the account chip and the line under it. */
export interface SessionIdentity {
  /** The larger line, and the string the initials avatar is derived from. */
  name: string;
  /** The smaller line beneath it. Null means "fall back to the role label". */
  sub: string | null;
}

/**
 * Decide who the console says is signed in: the account's own name, else its email, so the chip
 * is never empty. The line beneath is the email whenever a name won; it is null only when the
 * email has already been used as the name, leaving the role to fill the space.
 */
export function sessionIdentity(user: SessionUser): SessionIdentity {
  const named = user.name?.trim() || "";
  return named ? { name: named, sub: user.email } : { name: user.email, sub: null };
}
